var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CrudList',{attrs:{"title":"Sub Admin","storeName":"User_enterprises","labelAddNew":"Agregar","sortable":"","next-link":"/admin/deleted_users","breadcrumbs":[
    {
      text: 'Gestión de usuarios',
      disabled: false,
      href: '/admin/user_enterprises'
    },
    {
      text: 'Sub admin',
      disabled: false,
      href: '#'
    },
  ],"canSearch":""},scopedSlots:_vm._u([{key:"profile_picture",fn:function({ item }){return [_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[(item.profile_picture)?_c('v-list-item-avatar',[_c('img',{attrs:{"src":item.profile_picture,"alt":""}})]):_vm._e()],1)],1)]}},{key:"completed_name",fn:function({item}){return [_vm._v(" "+_vm._s(item.name || '')+" "+_vm._s(item.last_name || '')+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }